import src from "IMAGE";
export default { src, width: 256, height: 255, blurWidth: 0, blurHeight: 0};
